import takeRequest from '~/store/takeRequest';
import * as FilesActions from './actions';

export function* filesSaga() {
  yield takeRequest(FilesActions.getFileHistory);
  yield takeRequest(FilesActions.getHistoryFile);
  yield takeRequest(FilesActions.getFiles);
}
